import { object, string, ObjectSchema, AnyObject } from 'yup'
import { ACHFormData } from './ach-inputs'
import { OrderContactSlice } from 'modules/order/state/contact/contact-types'

// Combined form data type for ACH with donor info (no address fields needed)
export interface ACHWithDonorInfoFormData extends ACHFormData {
  email: string
  firstName: string
  lastName: string
}

export const makeACHWithDonorInfoValidationSchema = (
  t: (key: string, fallback: string) => string,
  contactSchema: ObjectSchema<AnyObject>, // order.contact.schema from parent
) => {
  return object({
    email: contactSchema.fields.email,
    firstName: contactSchema.fields.firstName,
    lastName: contactSchema.fields.lastName,

    // ACH specific fields
    routingNumber: string()
      .required(
        t('bankDetailsStep.validation.routingNumberRequired', 'Routing number is required.'),
      )
      .matches(
        /^[0-9]{9}$/,
        t(
          'bankDetailsStep.validation.routingNumberInvalid',
          'Please enter a valid routing number.',
        ),
      ),
    accountNumber: string().required(
      t('bankDetailsStep.validation.accountNumberRequired', 'Account number is required.'),
    ),
  })
}

// Default values for the combined form
export const makeACHWithDonorInfoDefaultValues = (
  contactValue: OrderContactSlice,
): ACHWithDonorInfoFormData => ({
  email: contactValue.email,
  firstName: contactValue.firstName,
  lastName: contactValue.lastName,
  routingNumber: '',
  accountNumber: '',
})
